/**
 * Whether a driver has already dispatched this ticket.
 *
 * These entities carry no dispatched flag - isReceived is the only status field
 * - so it is inferred from what dispatch persists: loading details plus at least
 * one detail only the driver supplies (a plate or truck number for small
 * quantity and rubble, a signature for hydrovac).
 *
 * Time Loaded alone is not enough: staff can set it from the edit view without
 * any driver involvement, and treating that as dispatched would lock the driver
 * out of the form. Clearing Time Loaded is therefore how staff reopen a ticket.
 *
 * Read the server's ticket before any client-side Time Loaded prefill, or every
 * ticket looks dispatched.
 */
export const hasBeenDispatched = (
  timeLoaded: Date | string | null | undefined,
  ...driverEvidence: (string | null | undefined)[]
) => !!timeLoaded && driverEvidence.some((value) => !!value);
